import React from "react";
import Dropdown from "../Dropdown/Dropdown";

const YearsDropdown = ({ onChange, value }) => {
    const getYearOptions = () => {
        const options = [];
        const currentDate = new Date();

        for (let i = 0; i >= -20; i--) {
            const year = currentDate.getFullYear() + i;
            options.push({ id: `${year}`, name: `${year}` }); // Store as id, name
        }
        return options;
    };

    return (
        <Dropdown
            options={getYearOptions()}
            placeholder="Select a Year"
            value={value}
            onSelect={onChange}
        />
    );
};

export default YearsDropdown;